// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"738ab51f","678":"6d1a7b74","737":"814407df","739":"33a9a8c1","980":"d46c02b5"}[chunkId] + ".chunk.css";
};